module.exports = __webpack_public_path__ + "media/20.935f5b0f.mp3";